import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4aa8a56f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4aa8a56f&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=4aa8a56f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8a56f",
  null
  
)

export default component.exports